// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".userChineselogin[data-v-7a1ba83a]  .el-form--label-top .el-form-item__label{height:26px}.userChineselogin[data-v-7a1ba83a]  .el-form-item{margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
